export const GA_MEASUREMENT_ID = "";
export const FB_PIXEL_ID = "9732686903507479";

// Función para enviar PageView a GA4 y Facebook Pixel
export const trackPageView = (url) => {
  if (GA_MEASUREMENT_ID && typeof window.gtag === 'function') {
    window.gtag('config', GA_MEASUREMENT_ID, {
      page_path: url,
    });
    // console.log(`GA PageView tracked for: ${url}`);
  }

  if (FB_PIXEL_ID && typeof window.fbq === 'function') {
    window.fbq('track', 'PageView');
    console.log(`FB Pixel PageView tracked for: ${url}`);
  }
};

// Función genérica para enviar eventos personalizados
export const trackEvent = (eventName, params) => {
  if (GA_MEASUREMENT_ID && typeof window.gtag === 'function') {
    window.gtag('event', eventName, params);
    // console.log(`GA Event tracked: ${eventName}`, params || '');
  }
  if (FB_PIXEL_ID && typeof window.fbq === 'function') {
    window.fbq('trackCustom', eventName, params);
    // console.log(`FB Pixel Event tracked: ${eventName}`, params || '');
  }
};

// Funciones específicas para eventos comunes
export const trackClick = (location) => {
  trackEvent("Lead", {
    event_category: "CTA",
    event_label: `Click enlace - ${location}`,
    button_location: location,
  });
};
